import styled from 'styled-components';
import { Result as AntResult } from 'antd';

export const Result = styled(AntResult)`
  *.ant-result-title {
    @media (max-width: 600px) {
      font-size: 1.125rem;
    }
    @media (min-width: 601px) and (max-width: 1024px) {
      font-size: 1.25rem;
    }
    @media (min-width: 1025px) {
      font-size: 1.5rem;
    }
  }
  &.ant-result-success .ant-result-icon > .anticon {
    color: var(--success-color);
  }

  &.ant-result-info .ant-result-icon > .anticon {
    color: var(--primary-color);
  }
  &.ant-result-warning .ant-result-icon > .anticon {
    color: var(--warning-color);
  }
  &.ant-result-error .ant-result-icon > .anticon {
    color: var(--error-color);
  }

  .ant-result-subtitle {
    color: var(--breadcrumb-color);
  }
`;
